<template>
    <div class="loading" v-show="visible">
        <div style="width:100%;height:100%" class="loading--inner">
            <div></div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Loading',
  data () {
    return {
      
    }
  },
  props: {
    visible: false
  }
}
</script>

<style scoped lang="scss">
    @keyframes loading--inner {
        0% { transform: translate(-50%, -50%) rotate(0deg); }
        100% { transform: translate(-50%, -50%) rotate(360deg); }
    }
    .loading {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(255,255,255,.6);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 20;
        &--inner {
            position: relative;
            div, div:after {
                position: absolute;
                width: 160px;
                height: 160px;
                border: 20px solid #0000FF;
                border-top-color: transparent;
                border-radius: 50%;
            }
            div {
                animation: loading--inner 1.3s linear infinite;
                top: 100px;
                left: 100px;
                &:after {
                    transform: rotate(90deg);
                }
            }
            width: 200px !important;
            height: 200px !important;
            transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
        }
    }
</style>


// WEBPACK FOOTER //
// Loading.vue?588fb368